<template>
    <div>
        <b-modal
            id="remove-field"
            ref="modal"
            title="Remove Field"
            size="sm"
            hide-footer
            :hide-header-close="loading"
            no-close-on-backdrop
            no-close-on-esc
            modal-class="hide-footer"
            @hidden="hideModal()"
        >
            <b-form @submit.stop.prevent="remove()" @reset="hideModal">
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <p>Are you sure to want to remove this field ?</p>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Remove"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                        :disabled="loading"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    props: {
        index: {
            type: Number,
        },
    },

    data() {
        return {}
    },
    watch: {
        hidePopup(value) {
            if (value) {
                this.hideModal()
            }
        },
    },
    methods: {
        remove() {
            let self = this
            if (this.$parent.formData.length >= 1) {
                this.$store.commit('setLoading', true)
                this.$parent.formData.splice(this.index, 1)
                this.$store.commit(
                    'setSuccess',
                    'Field has been removed. Please click on Update to save the changes.'
                )

                this.$store.commit('setChangeDetect', true)

                setTimeout(function () {
                    self.$store.commit('setLoading', false)
                    self.$refs.modal.hide()
                }, 2000)
            } else {
                this.$store.commit('setSuccess', 'Field cannot be less than 1')
                setTimeout(function () {
                    self.$store.commit('setLoading', false)
                    self.$refs.modal.hide()
                }, 2000)
            }
        },

        hideModal() {
            this.$emit('hide-modal')
            this.$refs.modal.hide()
            this.$validator.reset()
        },
    },
    computed: {
        ...mapGetters(['loading']),
    },
}
</script>
